import { Navigate, Outlet, RouteProps } from "react-router-dom";
import { isAuthenticated } from "../common/utils";
import { LOGIN } from "./routes";

const ProtectedRoute: React.FC<RouteProps> = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to={LOGIN} />;
};

export default ProtectedRoute;
